export const common = {
    ASC: 'asc',
    DESC: 'desc',
    DEV_ENV: 'development',
    TEST_ENV: 'test',
    PROD_ENV: 'production',
    API_TYPE: 'api',
    APP_TYPE: 'app',
    END_USER: 'END_USER'
}


// WEBPACK FOOTER //
// ./src/common/constants/common.js